export default "__VITE_ASSET__Evhhpar8__"